import {
    SET_REFRESH_PURCHASE_ORDER,
    SET_PO_PDF_LINK_PONUMBER
} from "./FleetRefreshPurchaseOrderType"

const initialState = {
    isPurchaseOrderRefreshed: null,
    poPdfLinkByPONumber: null
}


const reducer = (state = initialState, action: any) => {
    if (action.type === SET_REFRESH_PURCHASE_ORDER) {
        return {
            ...state,
            isPurchaseOrderRefreshed: action.isPurchaseOrderRefreshed
        };
    }else if (action.type === SET_PO_PDF_LINK_PONUMBER) {
        return {
            ...state,
            poPdfLinkByPONumber: action.poPdfLinkByPONumber
        };
    }
    return state;

};

export default reducer;